module.exports = __webpack_public_path__ + "img/v1-library-filters-mobile.fbd2e26c.png";